import Color from "../../colors/Color";
import { VariableReference } from "../../variables/Variables";

export interface Point {
    x: number;
    y: number;
}

export interface ColorStop {
    position: number;
    color: Color;
    variableReferences?: VariableReference[];
}

export const GRADIENT_TYPES = ["linear", "radial", "angular"] as const;

export type GradientType = typeof GRADIENT_TYPES[number];

export default interface Gradient {
    type: GradientType;
    from: Point;
    to: Point;
    colorStops: ColorStop[];
    angle?: number;
    scale?: number;
    aspectRatio?: number;
}
